import * as React from "react";

import { PresentationSortingOption } from "../../model";

import { usePlpAnalytics } from "../plp-analytics-provider";

import { useProductListController_forSorting } from "../product-list-provider";

interface PlpPresenterForTheSortingMenuConsumerInterface {
  showTheSortingMenu_onMobile: boolean;
  handleShowTheSortingMenu_onMobile: () => void;
  handleHideTheSortingMenu_onMobile: () => void;
  handleActionSortingOption: (option: PresentationSortingOption) => void;
}

const defaultValue = {};

const PlpPresenterForTheSortingMenuContext = React.createContext(
  defaultValue as PlpPresenterForTheSortingMenuConsumerInterface
);

export const PlpPresenterForTheSortingMenuProvider: React.FunctionComponent<
  React.ReactNode
> = (props) => {
  const { analytics } = usePlpAnalytics();

  const {
    chooseSortingOption: productListController_forSorting_chooseSortingOption,
  } = useProductListController_forSorting();

  const [showTheSortingMenu_onMobile, setShowTheSortingMenu_onMobile] =
    React.useState(false);

  const handleShowTheSortingMenu_onMobile = React.useCallback(() => {
    setShowTheSortingMenu_onMobile(true);
  }, []);
  const handleHideTheSortingMenu_onMobile = React.useCallback(() => {
    setShowTheSortingMenu_onMobile(false);
  }, []);
  const handleActionSortingOption = React.useCallback(
    (option: PresentationSortingOption) => {
      productListController_forSorting_chooseSortingOption(option);
      handleHideTheSortingMenu_onMobile();
      analytics.actionPlpSortingOption({
        sortingOption: option.label,
      });
    },
    [
      productListController_forSorting_chooseSortingOption,
      handleHideTheSortingMenu_onMobile,
      analytics,
    ]
  );

  const value: PlpPresenterForTheSortingMenuConsumerInterface = React.useMemo(
    () => ({
      showTheSortingMenu_onMobile,
      handleShowTheSortingMenu_onMobile,
      handleHideTheSortingMenu_onMobile,
      handleActionSortingOption,
    }),
    [
      showTheSortingMenu_onMobile,
      handleShowTheSortingMenu_onMobile,
      handleHideTheSortingMenu_onMobile,
      handleActionSortingOption,
    ]
  );
  return (
    <PlpPresenterForTheSortingMenuContext.Provider value={value}>
      {props?.children || []}
    </PlpPresenterForTheSortingMenuContext.Provider>
  );
};

export const usePlpPresenterForTheSortingMenu = () => {
  const context = React.useContext(PlpPresenterForTheSortingMenuContext);
  if (context === defaultValue) {
    throw new Error(
      "usePlpPresenterForTheSortingMenu must be used within a PlpPresenterForTheSortingMenuProvider"
    );
  }
  return context;
};
